import equal from 'fast-deep-equal';
import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateMetaSettings = (initialSettings, currentSettings) => {
  const settingsForSave = [];

  if (equal(initialSettings, currentSettings)) return settingsForSave;

  const settingsForUpdate = {
    ...initialSettings,
    ...currentSettings,
  };

  settingsForSave.push(setSiteMeta(['settings'], settingsForUpdate));

  return settingsForSave;
};

export default updateMetaSettings;
